import { Props } from '@components/BlockMapper';
import { Button } from '@components/Button/';
import Block from '@components/Layout/Block';
import { AdvisorHeadshot } from '@components/MiscComponents/AdvisorHeadShot';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import RichText from '@components/RichText';
import { Document } from '@contentful/rich-text-types';

import { FC } from 'react';
import {
  AdvisorWrapper,
  Container,
  ContentContainer,
  Eyebrow,
  Header,
  ImageWrapper,
  Text,
} from './styles';

const ThreeColumnTeam: FC<Props> = (props) => {
  const { eyebrow, header, people, bodyText, ctaText, ctaUrl } = props;
  return (
    <Block>
      <Container>
        {header && <Header data-testid="advisor-promo-header">{header}</Header>}

        <VerticalLineSeparator />

        <AdvisorWrapper $gridSize={people && people.length <= 2 ? people.length : undefined}>
          {people &&
            people.map((person, i) => (
              <ImageWrapper data-testid={`advisor-${i}`} key={person.key ? person.key : i}>
                <AdvisorHeadshot img={person.img} alt_text={person.name} />
              </ImageWrapper>
            ))}
        </AdvisorWrapper>

        {eyebrow && <Eyebrow data-testid="advisor-promo-eyebrow">{eyebrow}</Eyebrow>}

        <ContentContainer>
          {bodyText && (
            <Text>
              {typeof bodyText === 'object' ? (
                <RichText richText={bodyText as Document} />
              ) : (
                bodyText
              )}
            </Text>
          )}

          {ctaUrl && ctaText && (
            <Button
              dataTestId="meet-our-team-btn"
              arrow={true}
              variant={'tertiaryBlack'}
              url={ctaUrl}
              label={ctaText}
            />
          )}
        </ContentContainer>
      </Container>
    </Block>
  );
};

export default ThreeColumnTeam;
